import { KitchenOrder } from "../types";

export const getSectorNameForOrder = (order: KitchenOrder, showSectors: boolean): string => {
  const segment = order?.items?.[0]?.segment;
  if (segment?.name && showSectors) {
    return segment.name;
  }
  return '';
};
